import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ZoomInSvg from 'images/v5/icons/zoom-in.svg';
import ZoomOutSvg from 'images/v5/icons/zoom-out.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import Playground from 'layout/molecules/Playground';
import { selectSpecificationProjection, selectSpecificationProjectionsStatus, selectSpecificationProjectionsZoom, setZoom, } from 'store/specificationProjectionsSlice';
import env from 'utils/env';
import styles from './VisualEditor.module.scss';
function VisualEditor({ preview, menu }) {
    const dispatch = useDispatch();
    const activeProjection = useSelector(selectSpecificationProjection);
    const status = useSelector(selectSpecificationProjectionsStatus);
    const zoom = useSelector(selectSpecificationProjectionsZoom);
    const classes = classNames(styles.wrap);
    const handleChangeZoom = (v) => {
        if (v >= 50 && v <= 200) {
            dispatch(setZoom(v));
        }
    };
    const zoomDropdownValues = [50, 75, 100, 120, 150, 200];
    return (React.createElement("div", { className: classes },
        activeProjection && (React.createElement(Playground, { preview: preview, zoom: zoom, picture: `${env.static}/${activeProjection === null || activeProjection === void 0 ? void 0 : activeProjection.picture}`, points: activeProjection === null || activeProjection === void 0 ? void 0 : activeProjection.points.edges.map((point) => {
                return point.node;
            }), loading: status.fetchItem === 'idle' || status.fetchItem === 'loading' })),
        React.createElement("div", { className: styles.projectionsList }, status.fetch !== 'idle' || status.fetch !== 'loading' ? menu : React.createElement(Loader, null)),
        !preview && (React.createElement("div", { className: styles.zoomSettings },
            React.createElement("div", { style: {
                    overflow: 'hidden',
                    borderRadius: '8px',
                    background: 'var(--static-fill-foreground)',
                } },
                React.createElement(Button, { theme: "border", shape: "squared", leftIcon: React.createElement(ZoomInSvg, null), onClick: () => handleChangeZoom(zoom + 10), disabled: zoom === 200 })),
            React.createElement("div", { style: {
                    overflow: 'hidden',
                    borderRadius: '8px',
                    background: 'var(--static-fill-foreground)',
                } },
                React.createElement(Button, { theme: "border", shape: "squared", leftIcon: React.createElement(ZoomOutSvg, null), onClick: () => handleChangeZoom(zoom - 10), disabled: zoom === 50 })),
            React.createElement("div", { style: {
                    overflow: 'hidden',
                    borderRadius: '8px',
                    background: 'var(--static-fill-foreground)',
                } },
                React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "border" },
                        zoom,
                        "%") }, zoomDropdownValues.map((v) => (React.createElement(Button, { key: v, align: "left", theme: v === zoom ? 'fill' : 'ghost', onClick: () => handleChangeZoom(v) },
                    v,
                    "%")))))))));
}
export default VisualEditor;
